import React, { PureComponent } from "react";
import "./index.css";
import { Row, Col } from "reactstrap";
import Deputet from "../../components/Deputet";
import { getAnetaret } from "./data";
import { Input, Spin } from "antd";

const { Search } = Input;

class Deputetet extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filtro: "",
      anetaret: [],
      spinning: true
    };
  }

  componentWillMount = async () => {
    let anetaret = await getAnetaret();
    this.setState({ anetaret, spinning: false });
    console.log(anetaret);
  };

  realTimeChange = e => {
    this.setState({ filtro: e.target.value });
  };

  render() {
    var anetaret = this.state.anetaret;
    let filterAnetar = anetaret.filter(anetar => {
      let all = anetar.emer + anetar.mbiemer;
      return all.toLowerCase().includes(this.state.filtro.toLowerCase());
    });
    console.log(filterAnetar, "filter");
    return (
      <div className="deputetet-wrapper">
        <div className="search-section">
          <Search
            placeholder="Kerko deputet"
            onSearch={value => console.log(value)}
            enterButton
            onChange={e => {
              this.realTimeChange(e);
            }}
          />
        </div>

        <Spin spinning={this.state.spinning} tip="Ne ngarkim..." size="large">
          <Row className="deputetet-cards-wrapper">
            {filterAnetar.length > 0 ? (
              filterAnetar.map(anetar => {
                return (
                  <Col className="deputetet-body" xs="5" sm="5" md="4" lg="2">
                    <Deputet
                      emri={anetar.emer}
                      vendlindje={anetar.qarku}
                      mbiemri={anetar.mbiemer}
                      datelindja={anetar.dateLindje.slice(0, 10)}
                      foto={
                        "https://www.parlament.al/Files/AnetareFoto/" +
                        anetar.emer
                          .toLowerCase()
                          .replace("ç", "c")
                          .replace("ë", "e") +
                        anetar.mbiemer
                          .toLowerCase()
                          .replace("ç", "c")
                          .replace("ë", "e") +
                        "_foto.jpg"
                      }
                    />
                  </Col>
                );
              })
            ) : (
              <div className="no-result">
                {this.state.spinning ? null : "Nuk Ka Asnje Rezultat"}
              </div>
            )}
          </Row>
        </Spin>
      </div>
    );
  }
}

export default Deputetet;
